import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import { homeCompanyImage } from '../../assets/siteImages';
import { fadeUp, scrollViewport } from '../../motion/presets';
import '../home-why/home-why.scss';
import './home-company.scss';

const HomeCompany = () => {
  const { content } = useTranslation();
  const c = content.home.company;

  return (
    <section className="parent-bg section-full home-company" aria-labelledby="home-company-title">
      <div className="container home-why__shell">
        <motion.div
          className="home-why__card"
          initial="hidden"
          whileInView="visible"
          viewport={scrollViewport}
          variants={fadeUp}
        >
          <div className="home-why__card-inner">
            <figure className="home-why__media">
              <img
                className="home-why__photo"
                src={homeCompanyImage}
                alt={c.photoAlt}
                loading="lazy"
                decoding="async"
              />
            </figure>

            <div className="home-why__copy">
              <div className="home-why__accent" aria-hidden="true" />
              <p className="home-company__kicker">{c.kicker}</p>
              <h2 id="home-company-title" className="home-why__title">
                {c.title}
              </h2>
              <p className="home-why__lead">{c.lead}</p>

              <div className="home-company__chips" aria-label={c.chipsAria}>
                {c.chips.map((chip) => (
                  <span key={chip} className="home-company__chip">
                    {chip}
                  </span>
                ))}
              </div>

              <div className="home-why__rule-wrap">
                <hr className="divider-soft" />
              </div>
              <p className="home-why__closing home-company__foot">{c.foot}</p>
              <Link className="home-company__cta" to="/about">
                {c.cta} <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeCompany;
